import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { categories, articles } from "@/mocks/data";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { siteInfo } from "@/mocks/data";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || "sports");

  useEffect(() => {
    if (slug) {
      setActiveCategory(slug);
    }
  }, [slug]);

  const currentCategory = categories.find((c) => c.id === activeCategory);
  const categoryArticles = articles.filter((a) => a.categoryId === activeCategory);

  const categorySchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `${currentCategory?.name || ""} - ${siteInfo.name}`,
    description: currentCategory?.description || "",
    url: `https://www.damanguan-official.com/category/${activeCategory}`,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(categorySchema) }}
      />
      <main className="min-h-screen bg-background-50">
        <div className="pt-20">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: currentCategory?.name || "" },
            ]}
          />
        </div>

        {currentCategory && (
          <section className="relative mb-10">
            <div className="relative h-[280px] md:h-[360px] overflow-hidden">
              <img
                src={currentCategory.image}
                alt={currentCategory.name}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-black/20"></div>
              <div className="absolute bottom-0 left-0 w-full p-6 md:p-10 max-w-7xl mx-auto">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-xl">
                    <i className={`${currentCategory.icon} text-white text-lg`}></i>
                  </div>
                  <h1
                    className="text-2xl md:text-3xl font-bold text-white"
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    {currentCategory.name}
                  </h1>
                </div>
                <p className="text-white/70 text-sm md:text-base max-w-2xl">
                  {currentCategory.description}
                </p>
              </div>
            </div>
          </section>
        )}

        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-16">
          <div className="flex flex-wrap items-center gap-2 mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === cat.id
                    ? "bg-primary-500 text-white shadow-sm"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200"
                }`}
              >
                <i className={`${cat.icon} mr-1.5`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <h2 className="text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                      {article.summary}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.date}</span>
                      <span>{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                <i className="ri-file-list-3-line text-foreground-400 text-2xl"></i>
              </div>
              <p className="text-foreground-500">暂无相关文章</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}